// import {
//   Routes,
//   Route
// } from "react-router-dom";

// import AuthPage from "../components/login/Auth";
// import DashboardLayout from "../layouts/DashboardLayout";

// import Dashboard from "./Admin/Dashboard";
// import Projects from "./Admin/Projects/Projects";
// import Templates from "./Admin/template/Templates";
// import PMApprovals from "./Admin/Pm/PmPage";
// import ProjectRequests from "./Admin/ProjectReq/ProjectReq";
// import PmDashboard from "./PM/Dashboard";
// import MyProjects from "./PM/Projects/MyProjects";
// import RequestProject from "./PM/ProjectReq/RequestProj";



// function AppRoutes() {
//   return (
//     <Routes>
//       {/* LOGIN */}
//       <Route
//         path="/"
//         element={<AuthPage />}
//       />

//       {/* ADMIN ROUTES */}
//       <Route
//         path="/admin"
//         element={<DashboardLayout />}
//       >
//         <Route
//           path="dashboard"
//           element={<Dashboard />}
//         />

//         <Route
//           path="projects"
//           element={<Projects />}
//         />

//         <Route
//           path="templates"
//           element={<Templates />}
//         />

//         <Route
//           path="pm-approvals"
//           element={<PMApprovals />}
//         />

//         <Route
//           path="project-requests"
//           element={<ProjectRequests />}
//         />
//       </Route>

//       {/* PM ROUTES */}
//       <Route
//         path="/pm"
//         element={<DashboardLayout />}
//       >
//         <Route
//           path="dashboard"
//           element={<PmDashboard />}
//         />
//         <Route
//           path="projects"
//           element={<MyProjects />}
//         />
//         <Route
//           path="request-service"
//           element={<RequestProject />}
//         />
//       </Route>
//     </Routes>
//   );
// }

// export default AppRoutes;


import { Routes, Route } from "react-router-dom";

import AuthPage from "../components/login/Auth";
import DashboardLayout from "../layouts/DashboardLayout";
import ProtectedRoute from "./ProtectedRoute";

import Dashboard from "./Admin/Dashboard";
import Projects from "./Admin/Projects/Projects";
import Templates from "./Admin/template/Templates";
import PMApprovals from "./Admin/Pm/PmPage";
import ProjectRequests from "./Admin/ProjectReq/ProjectReq";

import PmDashboard from "./PM/Dashboard";
import MyProjects from "./PM/Projects/MyProjects";
import RequestProject from "./PM/ProjectReq/RequestProj";
import LogsDashboard from "./Admin/logs/Logs";

function AppRoutes() {
  return (
    <Routes>
      {/* LOGIN */}
      <Route path="/" element={<AuthPage />} />

      {/* ADMIN ROUTES */}
      <Route
        path="/admin"
        element={
          <ProtectedRoute allowedRoles={["Admin"]}>
            <DashboardLayout />
          </ProtectedRoute>
        }
      >
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="projects" element={<Projects />} />
        <Route path="templates" element={<Templates />} />
        <Route path="pm-approvals" element={<PMApprovals />} />
        <Route path="project-requests" element={<ProjectRequests />} />
        <Route path="logs" element={<LogsDashboard />} />
      </Route>

      {/* PM ROUTES */}
      <Route
        path="/pm"
        element={
          <ProtectedRoute allowedRoles={["PM"]}>
            <DashboardLayout />
          </ProtectedRoute>
        }
      >
        <Route path="dashboard" element={<PmDashboard />} />
        <Route path="projects" element={<MyProjects />} />
        <Route path="request-service" element={<RequestProject />} />
      </Route>
    </Routes>
  );
}

export default AppRoutes;